import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/v2/Badge';

export default class FilterItem extends Component {
  render() {
    const { label } = this.props;
    return (
      <Badge color="blue" withRemove onRemove={this.props.onRemoveFilter}>
        {label}
      </Badge>
    );
  }
}

FilterItem.propTypes = {
  label: PropTypes.string.isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
};
